import {
    keyFetchUserLogin,
    keyIsLoggedIn,
    GlobalLoading
} from '../constants';
import doFetch from '../../infra/helper/fetchHelper'
import { SetUserLogout, ApiUrl2, UserToken } from '../../helper/HelperAuth';


// export default () => async (dispatch, getState) => {

//     SetUserLogout();

//     let isLoggedIn = false
//     let users = null

//     dispatch({ type: keyFetchUserLogin, users });
//     dispatch({ type: keyIsLoggedIn, isLoggedIn });
// };
export default () => async (dispatch, getState) => {
    console.log(UserToken);
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: true });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'users-logout';
    const argument = {
        method: 'POST',
        headers: {
            'Authorization':'Bearer '+Authorization,
        }
    };

    const response = await doFetch(url, argument);
    console.log(response);

    
    SetUserLogout();
    let isLoggedIn = false
    let users = null
    dispatch({ type: keyFetchUserLogin, users });
    dispatch({ type: keyIsLoggedIn, isLoggedIn });

    window.location = '/Login';
};